const indicator = ['|', '/', '-', '\\'];

const runWithProcessingIndicator = async <T>({
  msg,
  func,
}: {
  msg: string;
  func: () => Promise<T>;
}): Promise<T> => {
  let i = 0;
  const interval = setInterval(() => {
    process.stdout.write(`\r${msg} ${indicator[i]}`);
    i = (i + 1) % indicator.length;
  }, 1000);

  const result = await func();
  clearInterval(interval);
  process.stdout.write(`\r${msg} Done\n`);

  return result;
};

export default { runWithProcessingIndicator };
